import React from 'react'
import Vimeo from '@u-wave/react-vimeo';
import Spinner from '../../shared/Spinner';
import { GatsbyImage, IGatsbyImageData, getImage } from 'gatsby-plugin-image';
import { klaviyoHandleClientData } from '../../../services/klaviyo';
import { ClientAction } from '../../../store/order';
import { gtmHandleDataLayer } from '../../../services/gtm';
import { VideoProps } from '.';

const VimeoPlayer = ({ videoFieldProps, thumbnail }: VideoProps & { thumbnail: React.ReactNode }) => {

    const [loading, setLoading] = React.useState(true);

    const data = videoFieldProps.data;

    const className = data?.className || "";

    const handlePlay = () => {
        if (data.autoplay) return;
        klaviyoHandleClientData({
            action: ClientAction.videoPlay,
        });
        gtmHandleDataLayer({
            action: ClientAction.videoPlay,
        });
    }

    return (
        <>
            <div className={`relative ${className}`} style={{
                paddingBottom: (videoFieldProps.data?.ratio || "56.25") + "%"

            }}>
                <div>
                    <div className='absolute top-0 left-0 w-full h-full flex items-center justify-center'>
                        {thumbnail ? thumbnail : <Spinner />}
                    </div>
                </div>
                <Vimeo
                    responsive
                    video={videoFieldProps.data.videoId}
                    autoplay={data?.autoplay || false}
                    background={data?.background || false}
                    loop={data?.loop || false}
                    style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", opacity: loading ? 0 : 1, zIndex: 3 }}
                    onLoaded={() => setLoading(false)}
                    onPlay={handlePlay}
                    onError={(e) => console.error(e)}
                />
            </div>
        </>
    )
}
export default VimeoPlayer;